'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var _func_1 = require("./_func");
var $ = require("jquery");
var Staff;
(function (Staff) {
    var MyStaff = /** @class */ (function () {
        function MyStaff() {
            var self = this;
            self.countObject();
            $(function () {
                setInterval(function () {
                    self.changeSide();
                }, 3000);
            });
            $('#trigStaffCategory').change(function () {
                var value = $(this).val();
                self.changeView(value);
            });
        }
        MyStaff.prototype.changeView = function (value) {
            var elm = $('#trigStaffCategory option:selected'); //.prop('selected');
            var departmentId = elm.data('department');
            var divisionId = elm.data('division');
            if (value != 'all') {
                for (var i = 0; i < $('.bulletStaff').length; i++) {
                    var target = $('.bulletStaff').eq(i);
                    var departmentIds = target.data('department');
                    var divisionIds = target.data('division');
                    if (_func_1.default.inArray(departmentId, departmentIds) && _func_1.default.inArray(divisionId, divisionIds)) {
                        target.show();
                    }
                    else {
                        target.hide();
                    }
                }
            }
            else {
                $('.bulletStaff').show();
            }
        };
        MyStaff.prototype.countObject = function () {
            this.objCount = $('.bulletStaffAnimation').length;
        };
        MyStaff.prototype.changeSide = function () {
            var randomNumber = Math.floor(Math.random() * this.objCount);
            if (this.selectNumber != randomNumber) {
                $('.bulletStaffAnimation').removeClass('on-anime');
            }
            this.selectNumber = randomNumber;
            $('.bulletStaffAnimation').eq(randomNumber).addClass('on-anime');
        };
        return MyStaff;
    }());
    Staff.MyStaff = MyStaff;
})(Staff || (Staff = {}));
exports.default = Staff;
